import heroCrowd from '../../assets/images/about/about-hero-crowd.jpg';

const HeroSection = () => {
  return (
    <section className="relative w-full h-[520px] sm:h-[620px] md:h-[720px] lg:h-[890px] overflow-hidden bg-black">
      {/* Background image — cropped, never stretched: the beam runs down through
          the frame and the crowd sits along the bottom */}
      <img
        src={heroCrowd}
        alt="Crowd under a spotlight at a live show"
        className="absolute inset-0 w-full h-full object-cover object-[center_82%]"
      />
      {/* Overlay to keep the copy legible and blend into the next section */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/5 to-black/60" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-5 md:px-8">
        <h1 className="text-white font-light leading-none text-[40px] sm:text-[48px] md:text-[60px] lg:text-[80px]">
          ABOUT US
        </h1>
        <p className="mt-[14px] md:mt-[16px] text-white/90 font-light text-[15px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-[1.35]">
          Professionalizing creativity through
          <br className="hidden sm:block" />{' '}
          transparency, infrastructure, and excellence.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
